module.exports = __webpack_public_path__ + "img/BlendBuff-Isolation.535236ab.png";